import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
import {AIChatBox, AIChatBoxConfig} from "./AIChatBox.js";
const $ = jQuery;


export class ZIDXAISearch implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAISearchContainer";
    }
    render(){
        let self=this;

        // Extract session ID from URL path: /ai-search-form/{uuid}
        let initialSessionId:string|null = null;
        let pathname = window.location.pathname;
        let aiSearchPrefix = "/ai-search-form/";
        let prefixPos = pathname.indexOf(aiSearchPrefix);
        if (prefixPos !== -1) {
            let afterPrefix = pathname.substring(prefixPos + aiSearchPrefix.length).replace(/\/$/, "");
            // Validate UUID format
            if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(afterPrefix)) {
                initialSessionId = afterPrefix;
            }
        }

        let tokenCountStarted=false;
        let aiChatBoxConfig=new AIChatBoxConfig();
        aiChatBoxConfig.aiEndPointURL="/ai-search/";
        aiChatBoxConfig.initialSessionId = initialSessionId;
        aiChatBoxConfig.onSessionReady = function(sessionId:string) {
            // Update URL to include session ID for shareable/resumable links
            let targetPath = (prefixPos !== -1
                ? pathname.substring(0, prefixPos)
                : pathname.replace(/\/$/, "")) + aiSearchPrefix + sessionId;

            // Only update the state if the current path doesn't already match the target
            if (window.location.pathname !== targetPath) {
                window.history.replaceState({}, "", targetPath);
            }
        };
        aiChatBoxConfig.onPromptCallback=function(prompt:string):string {
            tokenCountStarted=false;
            return prompt;
        };
        aiChatBoxConfig.onText=function(data:string):string {
            return data;
        };
        aiChatBoxConfig.onJSON=function(data:any){
            console.log("Search results:", data);
        };
        aiChatBoxConfig.onXML=function(data:string){
            console.log("XML data:", data);
        };
        aiChatBoxConfig.onTokens=function(count:number){
            if (!tokenCountStarted) {
                aiChatBox.resetProgressBar();
                tokenCountStarted = true;
            }
            aiChatBox.updateProgressBar(count);
        };
        aiChatBoxConfig.onDataCompleteCallback=function(){
        };
        let chatEmbed=$("."+this.getPageClass()+".zidxPageActive .aifcChatEmbed", this.zidx.peakidxShadowRoot)[0];
        let aiChatBox=new AIChatBox(this.zidx, aiChatBoxConfig,  this.zidx.peakidxShadowRoot, chatEmbed, function() {});
    }
}